// extracted by mini-css-extract-plugin
export default {"productGroup_description":"ProductGroup_productGroup_description__rZCET","productGroup_container":"ProductGroup_productGroup_container__18lTt"};